function initialValues(props) {
  const { user } = props;

  return {
    id: user?.id,
    acceptSms: user?.acceptSms,
    acceptMarketing: user?.acceptMarketing,
    acceptSmsAt: user?.acceptSmsAt || null,
    acceptMarketingAt: user?.acceptMarketingAt || null,
  };
}

export default initialValues;
